import { render, staticRenderFns } from "./ReportItem.vue?vue&type=template&id=0ef01a90&scoped=true&"
import script from "./ReportItem.vue?vue&type=script&lang=js&"
export * from "./ReportItem.vue?vue&type=script&lang=js&"
import style0 from "./ReportItem.vue?vue&type=style&index=0&id=0ef01a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef01a90",
  null
  
)

export default component.exports